import {Component, Module} from 'app/decorators';
import tpl from './ui.location.picker.html';


@Module({
    name: "app.directives.ui.location.picker",
})
@Component({
    selector: 'blnd-ui-location-picker',
    bindings: {
        ngModel: '=',
        mode: '@?',
    },
    template: tpl,
})
export default class C {
    constructor (Config) {
        "ngInject";
        this.mode = this.mode || 'view';
        this.locations = Config.$config.ticket.ui_location;
    }

    $onDestroy () {
        delete this.locations;
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/ui.location.picker.js